import useBreakpoint3rdParty from 'use-breakpoint'

/**
 * It is important to bind the object of breakpoints to a variable for memoization to work correctly.
 * If they are created dynamically, try using the `useMemo` hook.
 */
const BREAKPOINTS = { xs: 0, sm: 640, md: 1024, lg: 1280, xl: 1536 }
export type Breakpoint = keyof typeof BREAKPOINTS

export function useBreakpoint() {
  const { breakpoint, maxWidth, minWidth } = useBreakpoint3rdParty(
    BREAKPOINTS,
    'lg', // default breakpoint ssr
  )

  return { breakpoint, maxWidth, minWidth }
}

export const useIsAtOrWiderThan = (breakpointTarget: keyof typeof BREAKPOINTS) => {
  const { breakpoint: breakpointCurrent } = useBreakpoint()

  const breakpoints = Object.keys(BREAKPOINTS)
  const indexOfTarget = breakpoints.indexOf(breakpointTarget)
  const indexOfCurrent = breakpoints.indexOf(breakpointCurrent)

  return indexOfCurrent >= indexOfTarget
}

export const useIsAtOrNarrowerThan = (breakpointTarget: keyof typeof BREAKPOINTS) => {
  const { breakpoint: breakpointCurrent } = useBreakpoint()

  const breakpoints = Object.keys(BREAKPOINTS)
  const indexOfTarget = breakpoints.indexOf(breakpointTarget)
  const indexOfCurrent = breakpoints.indexOf(breakpointCurrent)

  return indexOfCurrent <= indexOfTarget
}